// THIS FILE IS GENERATED DYNAMICALLY, DO NOT EDIT DIRECTLY!

define('manifest',['require','screens/assessment/assessment','screens/assessment/question','screens/drag-drop/drag-drop','screens/explore/explore-collection','screens/explore/explore','screens/menu/menu','screens/minigame-wrapper/minigame-wrapper-trick-or-treat','screens/minigame-wrapper/minigame-wrapper','screens/montage/montage','screens/multiple-choice/multiple-choice','screens/multiple-choice/question','screens/multiselect/multiselect','screens/object-orientation/object-orientation','screens/observe-assess/observe-assess','screens/observe-assess/question','screens/observe-assess/scene','screens/overlays/achievements-overlay','screens/overlays/course-complete','screens/overlays/games-overlay','screens/overlays/info-overlay - Copy','screens/overlays/info-overlay','screens/overlays/module-summary','screens/overlays/presentation-overlay','screens/overlays/scenario-overlay','screens/overlays/unlock-overlay','screens/presentation/presentation','screens/scenario-mapper/scenario-actor','screens/scenario-mapper/scenario-asset','screens/scenario-mapper/scenario-conversation','screens/scenario-mapper/scenario-dialog','screens/scenario-mapper/scenario-item','screens/scenario-mapper/scenario-link','screens/scenario-mapper/scenario-location','screens/scenario-mapper/scenario-mapper-radial-item','screens/scenario-mapper/scenario-mapper-radial-menu','screens/scenario-mapper/scenario-mapper-view','screens/scenario-mapper/scenario-mapper','screens/scenario-mapper/scenario-utils','screens/scenario-mapper/scenario-variable','screens/scenario-mapper/scenario','screens/skilldrill/skilldrill','screens/system-sim/system-sim','activities/activity-animation','activities/activity-attachpads','activities/activity-backblow','activities/activity-bandage','activities/activity-checkbreathing','activities/activity-compressions','activities/activity-info','activities/activity-openairway','activities/activity-placeholder','activities/activity-rescuebreaths','activities/activity-sort','activities/activity-thrusts','activities/activity-timer','activities/activity-ventilations','activities/airway-slider','activities/ordering-item','activities/ordering-node','activities/scenario-activity'],function(require) {
  'use strict';

  require('screens/assessment/assessment');
  require('screens/assessment/question');
  require('screens/drag-drop/drag-drop');
  require('screens/explore/explore-collection');
  require('screens/explore/explore');
  require('screens/menu/menu');
  require('screens/minigame-wrapper/minigame-wrapper-trick-or-treat');
  require('screens/minigame-wrapper/minigame-wrapper');
  require('screens/montage/montage');
  require('screens/multiple-choice/multiple-choice');
  require('screens/multiple-choice/question');
  require('screens/multiselect/multiselect');
  require('screens/object-orientation/object-orientation');
  require('screens/observe-assess/observe-assess');
  require('screens/observe-assess/question');
  require('screens/observe-assess/scene');
  require('screens/overlays/achievements-overlay');
  require('screens/overlays/course-complete');
  require('screens/overlays/games-overlay');
  require('screens/overlays/info-overlay - Copy');
  require('screens/overlays/info-overlay');
  require('screens/overlays/module-summary');
  require('screens/overlays/presentation-overlay');
  require('screens/overlays/scenario-overlay');
  require('screens/overlays/unlock-overlay');
  require('screens/presentation/presentation');
  require('screens/scenario-mapper/scenario-actor');
  require('screens/scenario-mapper/scenario-asset');
  require('screens/scenario-mapper/scenario-conversation');
  require('screens/scenario-mapper/scenario-dialog');
  require('screens/scenario-mapper/scenario-item');
  require('screens/scenario-mapper/scenario-link');
  require('screens/scenario-mapper/scenario-location');
  require('screens/scenario-mapper/scenario-mapper-radial-item');
  require('screens/scenario-mapper/scenario-mapper-radial-menu');
  require('screens/scenario-mapper/scenario-mapper-view');
  require('screens/scenario-mapper/scenario-mapper');
  require('screens/scenario-mapper/scenario-utils');
  require('screens/scenario-mapper/scenario-variable');
  require('screens/scenario-mapper/scenario');
  require('screens/skilldrill/skilldrill');
  require('screens/system-sim/system-sim');
  require('activities/activity-animation');
  require('activities/activity-attachpads');
  require('activities/activity-backblow');
  require('activities/activity-bandage');
  require('activities/activity-checkbreathing');
  require('activities/activity-compressions');
  require('activities/activity-info');
  require('activities/activity-openairway');
  require('activities/activity-placeholder');
  require('activities/activity-rescuebreaths');
  require('activities/activity-sort');
  require('activities/activity-thrusts');
  require('activities/activity-timer');
  require('activities/activity-ventilations');
  require('activities/airway-slider');
  require('activities/ordering-item');
  require('activities/ordering-node');
  require('activities/scenario-activity');

});

